import { event, GtagEvent } from "./event";

export interface SelectContent extends GtagEvent {
    content_type?:string;
    content_id?:string;
}
export const select_content = ($_?:SelectContent) => event('select_content',$_);